import React from "react";
import Logo from "../assets/yivo_symbol_noBgColor.png";

const About = () => {
  return (
    <div className="bg-gray-900 text-gray-100">
      {/* Hero Section */}
      <section className="py-20 px-4 text-center">
        <div className="max-w-5xl mx-auto">
          <img src={Logo} alt="Yivo Logo" className="h-24 mx-auto mb-6" />
          <h1 className="text-4xl sm:text-5xl font-bold text-purple-400 mb-6">
            About Yivo
          </h1>
          <p className="text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto">
            Yivo is a solo-developed cybersecurity platform designed to bridge
            critical gaps in the threat intelligence landscape. Its mission is
            to empower security professionals with actionable insights by
            centralizing access to diverse intelligence sources.
          </p>
        </div>
      </section>

      {/* Feature Summary Section */}
      <section className="bg-gray-600 py-16 px-4">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-[#2b2b40] rounded-2xl p-6 shadow-lg border border-gray-700">
            <h2 className="text-2xl font-semibold text-purple-300 mb-3">
              Search
            </h2>
            <p className="text-gray-300 leading-relaxed text-sm">
              Perform deep investigations on IOCs like IPs, domains, hashes, and
              URLs. Yivo aggregates threat data from open-source and commercial
              feeds to offer a consolidated risk profile.
            </p>
          </div>
          <div className="bg-[#2b2b40] rounded-2xl p-6 shadow-lg border border-gray-700">
            <h2 className="text-2xl font-semibold text-purple-300 mb-3">
              Discover
            </h2>
            <p className="text-gray-300 leading-relaxed text-sm">
              Hunt for domains impersonating your brand or identify cyberattacks or ransomware breaches tied to an entity of interest.
            </p>
          </div>
           <div className="bg-[#2b2b40] rounded-2xl p-6 shadow-lg border border-gray-700">
            <h2 className="text-2xl font-semibold text-purple-300 mb-3">
              Insights
            </h2>
            <p className="text-gray-300 leading-relaxed text-sm">
              A central hub for cyber threat intelligence analysis across several dimensions, 
              enabling users to interactively explore, track, and act upon data related to threat actors, ransomware victims, and detection coverage gaps.
            </p>
          </div>
          <div className="bg-[#2b2b40] rounded-2xl p-6 shadow-lg border border-gray-700">
            <h2 className="text-2xl font-semibold text-purple-300 mb-3">
              Share
            </h2>
            <p className="text-gray-300 leading-relaxed text-sm">
              Collaborate securely with peers and tools. Features
              support classifying IOCs, tagging, and submitting findings to Yivo and other platforms in the future.
            </p>
          </div>
        </div>
      </section>

      {/* Vision Section - Lighter Background */}
      <section className="bg-[#f3f4f6] py-16 px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-purple-600 mb-4">
            Duct-Taped, Ambitious, Hopefully Scalable
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            Yivo is a one-human project stitched together with caffeine, curiosity, and questionable optimism. It's modular, mostly works, and might even survive a traffic spike—who knows! The dream? To be your favorite cybersecurity sidekick. Let’s find out together. LFG.
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;
